import { fNumber } from './formatNumber'

export const dynamicTickAmount = (dataLength: number, tickAmount: number = 5) => {
  if (dataLength >= 4) {
    return tickAmount - 1
  }

  return dataLength - 1
}

export const integerFormatter = (value: string | number) => {
  if (typeof value !== 'undefined') return fNumber(value, { disabledDecimal: true })
  return value
}

export const getChartGridConfig = (strokeDashArray = 5) => {
  return {
    show: true,
    strokeDashArray,
    xaxis: {
      lines: {
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
  };
};
